import { Locales, HttpMethod } from '@previo/core'
import Http from '~/http/Http'
import { APIPaths } from '~/http/APIPaths'
import type { LocaleChangeRequestBody } from '~/http/locale/Locale'

export class LocaleAPI extends Http {
  set = (locale: Locales): Promise<null> => {
    return this.callAuthAPI<LocaleChangeRequestBody, null>(
      HttpMethod.PUT,
      { path: APIPaths.LOCALE },
      {
        shortcut: locale,
      },
    )
  }
}
